// Canonical amenity + inclusive-utility keys (legacy `has_*` / `inclusive_*`
// columns), stored in Property.amenities (JSONB dict[str, bool]).

export const AMENITY_KEYS: { key: string; label: string }[] = [
  { key: "has_bath", label: "Bath" },
  { key: "has_shower_separate", label: "Separate shower" },
  { key: "has_toilet_separate", label: "Separate toilet" },
  { key: "has_balcony", label: "Balcony" },
  { key: "has_roofterrace", label: "Roof terrace" },
  { key: "has_garden", label: "Garden" },
  { key: "has_garage", label: "Garage" },
  { key: "has_parking", label: "Parking" },
  { key: "has_elevator", label: "Elevator" },
  { key: "has_groundfloor", label: "Ground floor" },
  { key: "has_storage", label: "Storage" },
  { key: "has_airco", label: "Air conditioning" },
  { key: "has_fireplace", label: "Fireplace" },
  { key: "has_pets_allowed", label: "Pets allowed" },
  { key: "suitable_for_sharing", label: "Suitable for sharing" },
];

export const INCLUSIVE_KEYS: { key: string; label: string }[] = [
  { key: "inclusive_gas", label: "Gas" },
  { key: "inclusive_water", label: "Water" },
  { key: "inclusive_electricity", label: "Electricity" },
  { key: "inclusive_tv", label: "TV" },
  { key: "inclusive_internet", label: "Internet" },
  { key: "inclusive_servicecosts", label: "Service costs" },
];

/** Labels of the amenity/inclusive flags that are set true, for display. */
export function enabledAmenityLabels(amenities: Record<string, boolean>): {
  amenities: string[];
  inclusive: string[];
} {
  return {
    amenities: AMENITY_KEYS.filter((a) => amenities[a.key]).map((a) => a.label),
    inclusive: INCLUSIVE_KEYS.filter((a) => amenities[a.key]).map((a) => a.label),
  };
}
